import React from "react";
//import { Link } from "react-router-dom";
export default class List extends React.Component {
  state = { item: "", items: [] };
  handleChange = (e) => {
    this.setState({ ...this.state, item: e.target.value });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.item.length > 0) {
      return this.setState({
        item: "",
        items: [...this.state.items, this.state.item],
      });
    }
  };
  handleDelete = (index) => {
    const updatedItems = this.state.items.filter((f, i) => i !== index);
    return this.setState({
      ...this.state,
      items: updatedItems,
    });
  };
  render() {
    return (
      <div className="list shopping-list">
        <h1>Create your Shopping list</h1>
        <form onSubmit={this.handleSubmit}>
          <input
            type=""
            className="input-field"
            value={this.state.item}
            onChange={this.handleChange}
            required
          />
          <button className="btn btn-submit">Add</button>
        </form>
        <div className="items">
          {this.state.items.map((item, index) => {
            return (
              <div className="shop-item" key={index}>
                <h3>{item}</h3>
                <button
                  className="btn btn-danger-sm"
                  onClick={() => this.handleDelete(index)}
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
